"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loading = void 0;
const imagesloaded_1 = __importDefault(require("imagesloaded"));
const loadingContainer = document.querySelector(".js-loading");
const isLoadedClass = "is-loaded";
const minTime = 3000;
/**
 * ローディング画面を設定する
 *
 * @param swiper Swiper
 * @returns void
 */
const loading = (swiper) => {
    const startTime = new Date().getTime();
    if (!loadingContainer) {
        if (swiper.slides.length > 0) {
            swiper.autoplay.start();
        }
        return;
    }
    loadingContainer.classList.remove(isLoadedClass);
    loadingContainer.setAttribute("aria-hidden", "false");
    const loaded = (0, imagesloaded_1.default)(".js-wrap", { background: true });
    loaded.on("always", () => {
        const endTime = new Date().getTime();
        const diffTime = endTime - startTime;
        // 表示しておく最低時間（minTime）より前に読み込みが完了した場合は、
        // 差分の時間分待ってからローディングを完了にする
        if (diffTime < minTime) {
            setTimeout(() => {
                hideLoading(swiper);
            }, minTime - diffTime);
        }
        else {
            hideLoading(swiper);
        }
    });
};
exports.loading = loading;
/**
 * ローディング画面を非表示にして、Swiper の autoplay を開始する
 *
 * @param swiper Swiper
 * @returns void
 */
const hideLoading = (swiper) => {
    if (!loadingContainer) {
        return;
    }
    new Promise((resolve) => {
        loadingContainer.classList.add(isLoadedClass);
        loadingContainer.setAttribute("aria-hidden", "true");
        setTimeout(() => {
            resolve("success");
        }, 500);
    }).then(() => {
        loadingContainer.style.display = "none";
        if (swiper.slides.length > 0) {
            swiper.autoplay.start();
        }
    });
};
